import { render, staticRenderFns } from "./proxyEmployeeForm.vue?vue&type=template&id=6147ae98&scoped=true"
import script from "./proxyEmployeeForm.vue?vue&type=script&lang=js"
export * from "./proxyEmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./proxyEmployeeForm.vue?vue&type=style&index=0&id=6147ae98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147ae98",
  null
  
)

export default component.exports